import { Button, Ref } from '@tblabs/truffle';


export class PrimaryButton extends Button
{
    constructor(label: string | Ref<string> = "...", onClick?: () => void, onDown?: () => void, onUp?: () => void)
    {
        super(label, onClick);
        this.Class("uk-button uk-button-primary")
            .Style("white-space: nowrap;")

        this.On("mousedown", () => onDown?.());
        this.On("touchstart", () => onDown?.());
        this.On("pointerdown", () => onDown?.());
        this.On("mouseup", () => onUp?.());
        this.On("touchend", () => onUp?.());
        this.On("pointerup", () => onUp?.());
    }
}
